import { getRootElement } from '@entities/helpers/get-root-element'
import { CssVariablesService } from '@module:css-variables'
import { PRELOADING_PSELECTOR } from '@constants/chat-corner'
import { $config } from '@store/config'
import { changePreloadingFlow } from '@store/system'
import { PreloadingFlow } from '@store/system/types'
import { Entity } from '@loctypes'
import content from './content.pug'

export default (entity: Entity) => {
  let html = content
  const rootElement = getRootElement(entity)
  const { modules } = $config.getState()
  const { edgeOffset, toggler } = modules.chat.corner

  changePreloadingFlow(PreloadingFlow.RUNNING)

  const iframe = document.createElement('iframe')
  iframe.name = 'flomni:preloading'
  iframe.width = iframe.height = '60px'
  iframe.style.border = 'none'
  iframe.style.position = 'fixed'
  iframe.style.right = iframe.style.bottom = `${edgeOffset}px`

  rootElement.querySelector(`#${PRELOADING_PSELECTOR}`)!.appendChild(iframe)

  html = html.replace('var(--preloading-bg)', CssVariablesService.mainColor)
  html = html.replace('"container"', `"container ${toggler.shape}"`)

  iframe.srcdoc = html

  // поиск ноды внутри iframe (srcdoc делает не моментальную вставку)
  const intervalId = setInterval(() => {
    const container = iframe.contentWindow!.document.querySelector('.container')

    if (container) {
      clearInterval(intervalId)

      container.addEventListener('animationend', function handler() {
        changePreloadingFlow(PreloadingFlow.COMPLETED)
        container.removeEventListener('animationend', handler)
      })
    }
  }, 1)
}
